<template>
  <div class="resource-state-tree" v-loading="loading">
    <project-resource-tree
      ref="tree"
      :class="enableEdit ? '' : 'disable-edit'"
      :projectid="project.id"
      @tree-loaded="onTreeLoaded"
    ></project-resource-tree>
    <div v-if="tree && tree.length > 0" class="oper-btns-wrap">
      <el-button size="mini" @click="exportRoleRes">导出</el-button>
      <el-button
        size="mini"
        @click="beginImportRoleRes"
        :loading="importLoading"
        >导入</el-button
      >

      <el-button
        v-if="!enableEdit"
        type="primary"
        size="mini"
        @click="beginEdit"
        >编辑权限</el-button
      >
      <template v-else>
        <el-button
          size="mini"
          type="primary"
          @click="endEdit"
          :loading="saveLoading"
          >保存权限</el-button
        >
        <el-button size="mini" @click="cancelEdit">取消</el-button>
      </template>
    </div>
    <form v-show="false" ref="importForm">
      <input
        type="file"
        ref="importFile"
        accept=".xlsx"
        @change="onImportRoleResFileChange"
      />
    </form>
  </div>
</template>
<script>
import {
  arrayEquals,
  getIdsData,
  foreachTreeItem,
  deepGetResTreeName
} from '../plugins/utils.js'
import { exportXlsxFile, readXlsxFileToJson } from '../plugins/exceljs'
export default {
  name: 'resource-state-tree',
  props: {
    active: Boolean, //组件是否激活
    project: Object,
    roleid: String,
    roleName: String,
    save: Function
  },
  data() {
    return {
      enableEdit: false, //是否启用权限编辑
      saveLoading: false,
      originalCheckedKeys: [],
      loading: false,
      importLoading: false,
      tree: []
    }
  },
  methods: {
    onTreeLoaded(tree) {
      this.tree = tree
    },
    getRoleRes() {
      if (this.roleid) {
        this.loading = true
        this.$post('/role/res', {
          id: this.roleid,
          project: this.project.id
        })
          .then((resp) => {
            this.loading = false
            if (resp.data.code == 0) {
              var resIds = getIdsData(resp.data.data, 'id')
              this.originalCheckedKeys = resIds
              this.$refs.tree.setCheckedKeys(resIds)
            } else {
              this.$message(resp.data.msg || '获取该角色资源失败')
            }
          })
          .catch((error) => {
            console.error('请求发生异常=>', error)
            this.loading = false
            this.$message('请求发生异常=>' + error)
          })
      } else {
        // this.$refs.tree.setCheckedKeys(this.treeIds)
      }
    },
    beginEdit() {
      this.enableEdit = true
    },
    cancelEdit() {
      var checkids = this.$refs.tree.getCheckedKeys()
      if (!arrayEquals(checkids, this.originalCheckedKeys)) {
        if (!confirm('放弃更改？')) {
          return
        }
        this.$refs.tree.setCheckedKeys(this.originalCheckedKeys)
      }

      this.enableEdit = false
    },
    async endEdit() {
      var checkids = this.$refs.tree.getCheckedKeys()
      this.saveLoading = true
      var flag = await this.save(checkids)
      this.saveLoading = false
      if (flag) {
        this.enableEdit = false
        this.refreshRoleRes()
      }
    },
    refreshRoleRes() {
      clearTimeout(window.refreshRoleResTimeout)
      window.refreshRoleResTimeout = setTimeout(() => {
        this.getRoleRes()
      }, 100)
    },
    refreshProjectResource() {
      if (this.$refs.tree) {
        this.$refs.tree.refreshProjectResource()
      }
    },
    refreshResourceStateTree() {
      this.refreshProjectResource()
      this.refreshRoleRes()
    },
    exportRoleRes() {
      if (!this.$refs.tree) {
        this.$message('组件未加载，请刷新页面')
        return
      }
      var allResourceData = this.$refs.tree.allResourceData
      var tree = this.$refs.tree.tree

      if (tree.length == 0) {
        this.$message('没有数据可导出')
        return
      }
      var data = []
      foreachTreeItem(tree, (row, rows) => {
        var result = []
        deepGetResTreeName(allResourceData, row.id, result)
        data.push({
          resid: row.id,
          resTreeName: result.reverse().join(' / '),
          have: this.originalCheckedKeys.includes(row.id) ? 1 : 0
        })
      })
      exportXlsxFile(
        `${this.project.name || ''}${this.project.name ? '_' : ''}${
          this.roleName || ''
        }${this.roleName ? '_' : ''}角色资源_${new Date().getTime()}.xlsx`,
        [
          { header: '资源id', key: 'resid', width: 35 },
          { header: '资源名称', key: 'resTreeName', width: 55 },
          { header: '是否拥有', key: 'have', width: 12 }
        ],
        {},
        data
      )
    },
    async beginImportRoleRes() {
      this.$refs.importFile.click()
    },
    async onImportRoleResFileChange(event) {
      var file = event.target.files[0]
      if (file) {
        console.log('file', file)
        var ext = file.name.split('.').pop()
        if (ext != 'xlsx') {
          this.$message('请上传xlsx文件')
          return
        }
        try {
          var data = await readXlsxFileToJson(file, {
            keyMap: {
              资源id: 'resid',
              资源名称: 'resTreeName',
              是否拥有: 'have'
            }
          })
          console.log('readXlsxFileToJson=>data', data)
          if (data.length == 0) {
            this.$message('没有数据可导入')
            return
          }
          if (data.some((item) => !item.resid)) {
            this.$message('资源id不能为空，请检查文件内容')
            return
          }
          var resids = []
          for (var item of data) {
            if (item.resid && item.have == 1) {
              resids.push(item.resid)
            }
          }
          await this.endImportRoleRes(resids)
        } catch (error) {
          console.error('读取xlsx文件发生异常=>', error)
          this.$message(`读取${file.name}文件失败，请检查文件内容`)
        } finally {
          this.$refs.importForm.reset()
        }
      }
    },
    async endImportRoleRes(resids) {
      this.importLoading = true
      var flag = await this.save(resids, '导入')
      if (flag) {
        this.refreshRoleRes()
      }
      this.importLoading = false
    }
  },
  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refreshResourceStateTree()
        }
      }
    },
    'project.id': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refreshProjectResource()
        }
      }
    },
    roleid: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.active) {
            this.refreshRoleRes()
          }
        } else {
          this.$refs.tree.setCheckedKeys([])
        }
      }
    }
  }
}
</script>
<style lang="less">
.resource-state-tree {
  height: 100%;
  overflow: auto;
  .el-checkbox {
    opacity: 1;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .disable-edit {
    .el-checkbox {
      opacity: 0.55;
      pointer-events: none;
    }
    .el-tree-node__content {
      cursor: default;
    }
  }
  .oper-btns-wrap {
    padding-top: 6px;
    position: sticky;
    bottom: 0;
    z-index: 5;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.7) 0%,
      rgba(255, 255, 255, 1) 40%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  &.el-loading-parent--relative {
    position: unset !important;
  }
}
</style>
